import(/* webpackMode: "eager" */ "/home/runner/work/searchright-0.1-fe/searchright-0.1-fe/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast","error"] */ "/home/runner/work/searchright-0.1-fe/searchright-0.1-fe/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/searchright-0.1-fe/searchright-0.1-fe/src/app/(root)/(main)/service/_components/FAQSection/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/searchright-0.1-fe/searchright-0.1-fe/src/app/(root)/(main)/service/_components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/searchright-0.1-fe/searchright-0.1-fe/src/components/common/CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/searchright-0.1-fe/searchright-0.1-fe/src/components/common/Slide.tsx");
